import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';
import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';
import ButtonRowGroup from './common/ButtonRowGroup';

import commonStyles from './styles';
import fundingButtonRowStyles from './styles/fundingButtonRow';

const styles = (theme) => {
  const common = commonStyles(theme);

  return {
    ...common,
    fundingButtonRow: fundingButtonRowStyles(theme),
  };
};

const FundingExtVerificationBare = ({
  bottomContent,
  children,
  classes,
  hasFields,
  label,
  labelMobile,
  name,
  resources,
}) => (
  <>
    <legend
      className={classnames('grp-label', classes.label)}
      role={!hasFields ? 'presentation' : undefined}
    >
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>
    <div className={classnames('funding-ext-verification-group-view', classes.fundingButtonRow)}>
      <RawHtml className={classnames('content', classes.content)}>
        {resources.frmPopupSubText}
      </RawHtml>

      <ErrorMsg name={name} type="group" />

      <div className={classnames('region-fields', classes.fields)}>{children}</div>

      <BottomContent className="bottomContent">{bottomContent}</BottomContent>

      <ButtonRowGroup groupName={name} />
    </div>
  </>
);

FundingExtVerificationBare.propTypes = {
  bottomContent: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  hasFields: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  resources: PropTypes.objectOf(PropTypes.string),
};

FundingExtVerificationBare.defaultProps = {
  bottomContent: '',
  hasFields: false,
  label: '',
  labelMobile: '',
  resources: {},
};

const FundingExtVerificationStyled = withStyles(styles)(FundingExtVerificationBare);

const mapStateToProps = ({ groups }, { name }) => {
  const group = groups[name];
  return {
    bottomContent: group.bottomContent,
    hasFields: group?.fields?.length > 0 ?? false,
    label: group.label,
    labelMobile: group.labelMobile,
    resources: group.resources,
    subText: group.subText,
  };
};

export default connect(mapStateToProps)(FundingExtVerificationStyled);
